import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface SkeletonRowProps {
  colCount: number;
  gridTemplate: string;
}

const SkeletonRow: React.FC<SkeletonRowProps> = ({ colCount, gridTemplate }) => (
  <Box sx={{
    display: 'grid',
    gridTemplateColumns: gridTemplate,
    gap: 1, px: 2, py: 1,
    borderBottom: '1px solid', borderColor: 'divider',
    alignItems: 'center',
  }}>
    {Array.from({ length: colCount }).map((_, i) => (
      <Skeleton key={i} height={20} sx={{ borderRadius: 0.5 }} />
    ))}
  </Box>
);

export default SkeletonRow;
